import { useState, useEffect } from 'react';
import { getChats, getChat } from '../api/chatApi';

export type Chat = {
  id: string;
  isGroup: boolean;
  name: string | null;
  lastMessageId: string | null;
  updatedAt: Date;
  tool: string;

  members: {
    id: string;
    chatId: string;
    userId: string;
    user: {
      email: string;
      isSciUser: boolean;
      name: string;
      country: string;
    }
  }[]

};

interface UseChatsResult {
  chats: Chat[];
  loading: boolean;
  error: string | null;
  setChats: (chats: Chat[]) => void
  getChat: (chatId: string) => Promise<Chat| null>;
}

export function useChats(): UseChatsResult {
  const [chats, setChats] = useState<Chat[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchUsers = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getChats();
      setChats(res.data ? res.data : []);
      console.log('chats', res.data);
    } catch (e: any) {
      setError('Failed to fetch users: ' + (e?.message || e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const getChatHandle = async (chatId: string) => {
    setLoading(true);
    setError(null);
    try {
      const res = await getChat(chatId);      
      return res.data;
    } catch (e: any) {
      setError('Failed to fetch users: ' + (e?.message || e));
      return null;
    } finally {
      setLoading(false);
    }
  }

  return { chats, loading, error, setChats,  getChat: getChatHandle };
}
